"use strict";
/**
 * @module Session
 */
Object.defineProperty(exports, "__esModule", { value: true });
var session_token_1 = require("./../session/session-token");
/**
 * Read a {@link SessionToken}
 *
 * @param  input  the input stream to read from
 * @return        a new session token
 */
function readSessionToken(input) {
    return new session_token_1.SessionToken(input.readMany(session_token_1.TOKEN_LENGTH));
}
exports.readSessionToken = readSessionToken;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/session/session-token-deserialiser.js
// module id = 1463
// module chunks = 1